import {ThemeColor} from '../../../../../common/enums/theme-color.enum';
import {AlertType} from '../../../../../common/enums/alert.enum';
import {AlertButtonClass} from '../../../../../models/popup-alert.model';

/**
 * Constant: Colour scheme names, also used as the scheme class on overlay panels and icons
 */
export const COLOR_SCHEME = {
  INSURER: 'insurer',
  BROKER: 'broker',
} as const;

export type ColorSchemeName = typeof COLOR_SCHEME[keyof typeof COLOR_SCHEME];

/**
 * Interface: Colour-scheme values derived once from the token and bound from templates and dialog configs
 */
export interface IColorSchema {
  readonly isInsurer: boolean;
  readonly schemeName: ColorSchemeName;
  readonly buttonColor: ThemeColor.Warn | ThemeColor.Primary;
  readonly menuPanelClass: string;
  readonly menuBorderClass: string;
  readonly autocompletePanelClass: string;
  readonly selectOverlayClass: string;
  readonly popupPanelClass: string;
  readonly alertType: AlertType.INSURER | AlertType.PRIMARY;
  readonly alertButtonClass: AlertButtonClass.WARN | AlertButtonClass.PRIMARY;
}

const INSURER_COLOR_SCHEMA: IColorSchema = Object.freeze({
  isInsurer: true,
  schemeName: COLOR_SCHEME.INSURER,
  buttonColor: ThemeColor.Warn,
  menuPanelClass: 'mat-menu--insurer',
  menuBorderClass: 'mat-menu--insurer-border',
  autocompletePanelClass: 'mat-autocomplete--dropdown--insurer',
  selectOverlayClass: 'overlay-pane--sobrado-select--insurer',
  popupPanelClass: 'sobrado-popup--insurer',
  alertType: AlertType.INSURER,
  alertButtonClass: AlertButtonClass.WARN,
});

const BROKER_COLOR_SCHEMA: IColorSchema = Object.freeze({
  isInsurer: false,
  schemeName: COLOR_SCHEME.BROKER,
  buttonColor: ThemeColor.Primary,
  menuPanelClass: '',
  menuBorderClass: 'mat-menu--broker-border',
  autocompletePanelClass: '',
  selectOverlayClass: 'overlay-pane--sobrado-select--broker',
  popupPanelClass: 'sobrado-popup--broker',
  alertType: AlertType.PRIMARY,
  alertButtonClass: AlertButtonClass.PRIMARY,
});

/**
 * Method: Resolve the frozen colour schema for one scheme
 * @param isInsurer - Whether the insurer scheme applies
 */
export function createColorSchema(isInsurer: boolean): IColorSchema {
  return isInsurer ? INSURER_COLOR_SCHEMA : BROKER_COLOR_SCHEMA;
}
